// extracted by mini-css-extract-plugin
module.exports = {"button":"StyledButton_button__mPwOO"};